import { gql } from '../../__generated__';

gql(`
  fragment UserCommentItem on UserComment {
    id
    comment
    createdByName
    createdAt
    lastUpdatedByName
    lastUpdatedAt
    isLocked
  }
`);

export const GET_COMMENTS = gql(`
  query GetUserComments($userId: Int!) {
    comments: userComments(id: $userId) {
      ...UserCommentItem
    }
  }
`);

export const REMOVE_COMMENT = gql(`
  mutation RemoveUserComment($input: UserRemoveCommentInput!) {
    userRemoveComment(input: $input) {
      id
    }
  }
`);
export const ADD_COMMENT = gql(`
  mutation AddUserComment($input: UserAddCommentInput!) {
    userAddComment(input: $input) {
      ...UserCommentItem
    }
  }
`);

export const UPDATE_COMMENT = gql(`
  mutation UpdateUserComment($input: UserUpdateCommentInput!) {
    userUpdateComment(input: $input) {
      ...UserCommentItem
    }
  }
`);
